(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '../../../elements', '../flowtypes'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../../../elements'), require('../flowtypes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.elements, global.flowtypes);
    global.ValidationWarnings = mod.exports;
  }
})(this, function (exports, _react, _elements, _flowtypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Paragraph = _elements.typography.Paragraph;


  var ValidationWarnings = function ValidationWarnings(_ref) {
    var warnings = _ref.warnings;
    return warnings.map(function (warning, i) {
      return _react2.default.createElement(
        'div',
        { key: 'warning' + (i + 0) },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            Paragraph,
            { color: 'soil' },
            warning.warningType,
            ':'
          )
        ),
        warning.warningMessages.map(function (message, j) {
          return _react2.default.createElement(
            'div',
            { key: 'warningMessage' + (j + 0) },
            _react2.default.createElement(
              Paragraph,
              { muted: true },
              message
            )
          );
        })
      );
    });
  };

  exports.default = ValidationWarnings;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/FileUploadStatusBox/components/ValidationWarnings.js
// module id = 2042
// module chunks = 1